import { useEffect } from 'react';

import { useTranslations } from '@dcentralexpedientedigital/fe-cms-api/hooks/use-translations';
import { useIntlStore } from '@dcentralexpedientedigital/fe-shared/stores/intl-store';

import { isTranslation } from '../utils/is-translation';

export function normalizeKey(key: string) {
    return key.replace(/[-_]/g, '_');
}

export function useUpdateTranslations() {
    const [locale, setTranslations] = useIntlStore((state) => [
        state.locale,
        state.setTranslations,
    ]);

    const { isLoading, isError, data } = useTranslations();

    useEffect(() => {
        const updateTranslationsInStore = async () => {
            try {
                if (isLoading || isError || !data) return;

                const translations: Record<string, Record<string, string>> = data.reduce(
                    (acc, curr) => {
                        if (curr?.translations && Array.isArray(curr.translations)) {
                            curr.translations.forEach((translation) => {
                                if (isTranslation(translation)) {
                                    const { languages_locale, translations_key, value } =
                                        translation;
                                    if (!acc[languages_locale]) {
                                        acc[languages_locale] = {};
                                    }

                                    const normalizedKey = normalizeKey(translations_key);
                                    acc[languages_locale][normalizedKey] = value;
                                }
                            });
                        }
                        return acc;
                    },
                    {} as Record<string, Record<string, string>>,
                );

                setTranslations(translations);
            } catch (error) {
                console.error('Error updating translations in store:', error);
            }
        };

        updateTranslationsInStore();
    }, [isLoading, isError, data, setTranslations, locale]);
}
